module.exports = vendor_0e0a3bab7aac21e79ca7;